module.exports = __webpack_public_path__ + "img/Pickup-Address.848fb6e1.jpg";